import { useEffect, useRef, useCallback } from 'react';

const IDLE_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'];

/**
 * Calls `onIdle` after 30 minutes without user interaction.
 * Resets on mousemove, keydown, scroll, click, touchstart.
 */
export default function useIdleTimeout(onIdle) {
  const timerRef = useRef(null);
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onIdleRef.current(), IDLE_TIMEOUT_MS);
  }, []);

  useEffect(() => {
    resetTimer();
    for (const evt of ACTIVITY_EVENTS) {
      document.addEventListener(evt, resetTimer, { passive: true });
    }
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      for (const evt of ACTIVITY_EVENTS) {
        document.removeEventListener(evt, resetTimer);
      }
    };
  }, [resetTimer]);
}
